<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';

import type { IEventPublisherItemDTO } from '~/shared/api/client/events/events-publisher.dto';
import { mapPublisherEventItems } from '~/shared/api/client/events/events-publisher.dto';
import { getEventRoute } from '~/shared/lib/getEventRoute';
import { useSwiperControlsVisibility } from '~/shared/lib/useSwiperControlsVisibility';
import { DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL } from '~/shared/lib/publishers.const';
import type { TPublisherStyleProps } from '~/shared/lib/publishers.types';
import SliderItem from '~/shared/ui/slider/SliderItem.vue';

const { $viewport } = useNuxtApp();

const props = withDefaults(
  defineProps<
    {
      items: IEventPublisherItemDTO[];
    } & TPublisherStyleProps
  >(),
  DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL,
);

const events = computed(() => mapPublisherEventItems(props.items));

const itemsCount = computed(() => events.value.length);
const isControlVisible = useSwiperControlsVisibility(
  itemsCount,
  $viewport.breakpoint,
);

const DATA = computed(() => ({
  title: 'Мероприятия',
  subTitle: 'Афиша',
  titleLink: '/events',
  arrowColor: props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL.textColor,
  borderColor:
    props.borderColor || DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL.borderColor,
  backgroundColor:
    props.backgroundColor ||
    DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL.backgroundColor,
  textColor: props.textColor || DEFAULT_PUBLISHER_STYLE_PROPS_RETAIL.textColor,
  breakpoints: true,
  isControlVisible: isControlVisible.value,
}));
</script>

<template>
  <Slider v-if="events.length > 0" v-bind="DATA">
    <SwiperSlide
      v-for="(item, key) in events"
      :key="`sliderRetail_${key}`"
      :style="{ borderColor: DATA.borderColor }"
      :class="$style.swiperSlide"
    >
      <SliderItem
        :id="item.event.id"
        :to="getEventRoute(item.event)"
        :text-color="DATA.textColor"
        :title="item.event.name"
        :subject="item.subject || null"
        :image="item.imageUrl"
        :author="null"
      />
    </SwiperSlide>
  </Slider>
</template>

<style module lang="scss">
.swiperSlide {
  width: 270px;
  height: auto;
  border-right: 1px solid;
}

@media (max-width: 767px) {
  .swiperSlide {
    border-right: none;
    width: 100%;
  }
}
</style>
